define(function(require) {
  const IpsModel = require('civicsBase/ipsModel');

  return IpsModel.extend({
      url: function(){
            return'/delegate/civics-api/api/anonymous/auth';
      }
  });
});
